import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductSupplier } from '../../types/product-supplier';

import { BarcodeComponent } from '@softline/ui-core/code';
import { ChipComponent } from '@softline/ui-core';
import { IconComponent } from '@softline/ui-core';
@Component({
    selector: 'soft-product-supplier-card',
    imports: [CommonModule,
    BarcodeComponent,
    ChipComponent,
    IconComponent],
    templateUrl: './product-supplier-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './product-supplier-card.component.css'
})
export class ProductSupplierCardComponent {
  productSupplier = input.required<ProductSupplier>();
}
